import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

export default function RequireRole({ allowed, children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (allowed && !allowed.includes(user.role)) {
    return (
      <div className="p-10">
        <h1 className="text-xl font-bold text-slate-800">Accès refusé</h1>
        <p className="text-sm text-slate-600 mt-2">Votre rôle ne dispose pas des droits pour cette page.</p>
      </div>
    );
  }
  return children;
}
